import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  margin: 0;
  padding: 0;
  border:1px solid #ededed;
  .PlanCard_wrapper {
    display: flex;
  }
  .PlanCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
  }
  .PlanCard_media {
    img {
      width: 100%;
      height: auto;
    }
  }
  .PlanCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${colors.color3Lightest};
    padding: 30px 20px 0 20px;
    h4 a {
      color: ${colors.body};
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      margin: 0;
      display: block;
    }
    h5 a {
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      color: ${colors.body};
      margin: 0;
      display: block;
    }
    .PlanCard_priceWrapper {
      border-top: 1px solid ${colors.color3};
      border-bottom: 1px solid ${colors.color3};
      display: flex;
      width: 45%;
      background-color: ${colors.color3Light};
      align-items: center;
      justify-content: center;
      .PlanCard_priceValue {
        font-size: 19px;
        font-weight: 400;
        margin: 0;
      }
    }
    .PlanCard_textList {
      list-style: none;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid ${colors.color3};
      flex-grow: 1;
      position: relative;
      .PlanCard_textListContent {
        margin: 0;
        padding: 0;
        list-style: none;
        position: absolute;
        background-color: #FFFFFF;
        top: 35px;
        box-shadow: 0 2px 3px rgba(0,0,0,.2);
        width: 100%;
        z-index: 5;
        li {
          font-size: 14px;
          font-weight: 600;
          padding: 8px 25px;
          border-bottom: 1px solid ${colors.color3};
          width: 100%;
          &:hover {
            background-color: ${colors.color3Lighter};
          }
          span {
            color: #666666;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
    .PlanCard_listHeader {
      font-size: 13px;
      font-weight: 400;
      line-height: 1;
      border-top: 1px solid ${colors.color3};
      padding: 10px;
      display: block;
      color: ${colors.body};
      &-submenu {
        background-image: url('/images/icon-triangle-green.svg');
        background-position: 95% center;
        background-repeat: no-repeat;
      }
    }
    .PlanCard_iconList {
      display: flex;
      list-style: none;
      margin: 0 0 15px 0;
      padding: 0;
      li {
        border-right: 1px solid ${colors.color3};
        width: 25%;
        text-align: center;
        padding: 12px 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        & > span {
          display: block;
        }
        &:last-child {
          border: 0;
        }
        .PlanCard_iconListIcon {
          margin: 0 0 4px 0;
        }
        .PlanCard_iconListValue {
          font-weight: 700;
        }
        .lighter {
          font-weight: 400;
        }
        a {
          color: ${colors.color1};
          font-weight: 700;
        }
        .PlanCard_linkIcon {
          width: 13px;
          height: 13px;
          margin: 5px 0 0 0;
        }
      }
    }
    .PlanCard_buttonWrapper {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      .PlanCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: #6C6C6C;
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
      }
      .PlanCard_detailButton {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.color2};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
  .PlanCard_iconList, .seriesDropdown {
    display:none !important;
  }
  .PlanCard_content {
    padding:20px;
  }
  .PlanCard_wrapper {
    border:3px solid white;
  }
`;

class PlanCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setToggleRef = this.setToggleRef.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  setToggleRef(node) {
    if (this.toggleRef) {
      this.toggleRef.removeEventListener('click', this.handleToggle);
    }

    this.toggleRef = node;
    if (this.toggleRef) {
      this.toggleRef.addEventListener('click', this.handleToggle);
    }
  }

  handleToggle(event) {
    event.preventDefault();

    this.setState({
      showMenu: !this.state.showMenu,
    });
  }

  handleClickOutside(event) {
    if (
      this.toggleRef
      && !this.toggleRef.isSameNode(event.target)
      && !this.toggleRef.contains(event.target)
      && this.state.showMenu
    ) {
      this.setState({
        showMenu: false,
      });
    }
  }

  render() {
    const { plan } = this.props;
    // const { showMenu } = this.state;
    // const parentId = plan.is_parent_plan ? plan._id : plan.parent_plan_select;
    // const series = plans.filter(item => (item.parent_plan_select === parentId));

    return (
      <div className={styles}>
        <div className="PlanCard_wrapper">
          <div className="PlanCard_inner">
            <div className="PlanCard_media">
              <Link name="plan-library-detail" plan={plan}>
                <Image
                  src={get(plan, 'photos[0].contentUrl', get(plan, 'elevationPhotos[0].contentUrl'))}
                  alt={get(plan, 'name', 'coming soon')}
                  width={800}
                  height={450}
                  exact
                />
              </Link>
            </div>
            <div className="PlanCard_content">
              <h4>
                <Link name="plan-library-detail" plan={plan}>
                  {get(plan, 'name')}
                </Link>
              </h4>
              {/* <div className="d-flex mt-3 seriesDropdown">
                <ul className="PlanCard_textList">
                  {
                    (series || []).length > 0 &&
                    <li>
                      <span ref={this.setToggleRef} className="PlanCard_listHeader
                      PlanCard_listHeader-submenu">
                        {(series || []).length} Elevations Available
                      </span>
                      {
                        showMenu &&
                        <ul className="PlanCard_textListContent">
                          {
                            series.map(seriesItem => (
                              <li key={seriesItem._id}>
                                <Link name="plan-library-detail" plan={seriesItem}>
                                  {get(seriesItem, 'name')} {' '}
                                </Link>
                              </li>
                            ))
                          }
                        </ul>
                      }
                    </li>
                  }
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  // plans: PropTypes.arrayOf(PropTypes.object),
  // widget: PropTypes.object,
};

// PlanCard.defaultProps = {
//   plans: [],
//   widget: undefined,
// };

export default withData({
  plan: true,
  // plans: true,
  // widget: 'coming_soon_image',
})(PlanCard);



// WEBPACK FOOTER //
// ./src/components/PlanCardOptions.js